/**
 * Coffee Club bundle card: Add vs quantity toggle + Add button click + View details modal.
 * Works with section-coffee-club-product-grid.min.js (listens to same state).
 */
(function () {
  "use strict";

  const BUNDLE_ITEM_SEL = ".js-coffee-club-bundle-item";
  const ADDON_ITEM_SEL = ".js-coffee-club-addon-item";
  const ADD_WRAP_SEL = ".js-coffee-club-add-wrap";
  const QTY_WRAP_SEL = ".js-coffee-club-qty-wrap";
  const ADD_BTN_SEL = ".js-coffee-club-add-btn";
  const PRICE_SEL = ".js-price";
  const VIEW_DETAILS_SEL = ".js-coffee-club-view-details";
  const STORAGE_NAME = "coffeeClub";
  const MODAL_ID = "ccProductDetailsModal";

  let modalPayload = null; // { variantId, title, url, image, variantTitle, comparePrice, price } for current modal product

  function getBundleLimit() {
    const state = getStateFromStorage();
    if (state && state.bundleLimit != null) return parseInt(state.bundleLimit, 10);
    const settings = window.coffeeClub && window.coffeeClub.settings;
    return settings && settings.bundleLimit != null ? parseInt(settings.bundleLimit, 10) : 5;
  }

  function getMaxAllowedQty(state, variantId) {
    const limit = state && state.bundleLimit != null ? parseInt(state.bundleLimit, 10) : getBundleLimit();
    const items = (state && state.bundleItems) || [];
    const total = items.reduce((sum, i) => sum + i.quantity, 0);
    const current = (items.find((i) => i.variantId === variantId) || {}).quantity || 0;
    return Math.max(0, limit - total + current);
  }

  function announce(message) {
    const el = document.getElementById("screenReaderStatus");
    if (el) {
      el.textContent = "";
      el.textContent = message;
    }
  }

  function formatMoney(cents) {
    if (typeof window.Shopify !== "undefined" && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD";
    const locale = (window.Shopify && window.Shopify.locale) || "en";
    return (cents / 100).toLocaleString(locale, { style: "currency", currency: currency });
  }

  function stripHtml(html) {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  function toggleAddQtyVisibility(state) {
    if (!state) return;
    const { bundleItems, addonItems, limitReached } = state;
    const bundleLimit = state.bundleLimit != null ? parseInt(state.bundleLimit, 10) : getBundleLimit();
    const bundleCards = document.querySelectorAll(BUNDLE_ITEM_SEL);
    bundleCards.forEach((card) => {
      if (card.dataset.disabled === "true") return;
      const addWrap = card.querySelector(ADD_WRAP_SEL);
      const qtyWrap = card.querySelector(QTY_WRAP_SEL);
      const addBtn = addWrap && addWrap.querySelector(ADD_BTN_SEL);
      if (!addWrap || !qtyWrap) return;
      const variantId = parseInt(card.dataset.variantId, 10);
      const entry = (bundleItems || []).find((item) => item.variantId === variantId);
      const qty = entry ? entry.quantity : 0;
      addWrap.setAttribute("aria-hidden", qty > 0 ? "true" : "false");
      qtyWrap.setAttribute("aria-hidden", qty > 0 ? "false" : "true");
      if (addBtn) {
        addBtn.disabled = !!limitReached;
        addBtn.setAttribute("aria-disabled", limitReached ? "true" : "false");
      }
    });
    const addonCards = document.querySelectorAll(ADDON_ITEM_SEL);
    addonCards.forEach((card) => {
      if (card.dataset.disabled === "true") return;
      const addWrap = card.querySelector(ADD_WRAP_SEL);
      const qtyWrap = card.querySelector(QTY_WRAP_SEL);
      const addBtn = addWrap && addWrap.querySelector(ADD_BTN_SEL);
      if (!addWrap || !qtyWrap) return;
      const variantId = parseInt(card.dataset.variantId, 10);
      const entry = (addonItems || []).find((item) => item.variantId === variantId);
      const qty = entry ? entry.quantity : 0;
      addWrap.setAttribute("aria-hidden", qty > 0 ? "true" : "false");
      qtyWrap.setAttribute("aria-hidden", qty > 0 ? "false" : "true");
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.setAttribute("aria-disabled", "false");
      }
    });
    // Sync modal add/qty visibility, input, and limit state when modal is open
    const modal = document.getElementById(MODAL_ID);
    if (modal && modal.getAttribute("aria-hidden") === "false" && modalPayload) {
      const addonModal = modalPayload._isAddon;
      const entry = addonModal
        ? (addonItems || []).find((item) => item.variantId === modalPayload.variantId)
        : (bundleItems || []).find((item) => item.variantId === modalPayload.variantId);
      const qty = entry ? entry.quantity : 0;
      const maxAllowed = addonModal ? 999 : getMaxAllowedQty(state, modalPayload.variantId);
      const addWrap = modal.querySelector(".js-cc-pd-modal-add-wrap");
      const qtyWrap = modal.querySelector(".js-cc-pd-modal-qty-wrap");
      const modalAddBtn = modal.querySelector(".js-cc-pd-modal-add-btn");
      const input = modal.querySelector(".cc-pd-modal__qty-input");
      const incBtn = modal.querySelector("[data-cc-pd-qty='increment']");
      if (addWrap) addWrap.setAttribute("aria-hidden", qty > 0 ? "true" : "false");
      if (qtyWrap) qtyWrap.setAttribute("aria-hidden", qty > 0 ? "false" : "true");
      if (input) {
        input.value = qty;
        input.max = maxAllowed;
        input.setAttribute("max", maxAllowed);
      }
      if (modalAddBtn) {
        modalAddBtn.disabled = addonModal ? false : !!limitReached;
        modalAddBtn.setAttribute("aria-disabled", addonModal ? "false" : limitReached ? "true" : "false");
      }
      if (incBtn) {
        const incBlocked = addonModal ? qty >= maxAllowed : !!limitReached || qty >= maxAllowed;
        incBtn.disabled = incBlocked;
        incBtn.setAttribute("aria-disabled", incBlocked ? "true" : "false");
      }
    }
  }

  function getStateFromStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_NAME);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function onAddButtonClick(ev) {
    const addBtn = ev.target.closest(ADD_BTN_SEL);
    if (!addBtn) return;
    if (addBtn.disabled) return;
    const bundleCard = addBtn.closest(BUNDLE_ITEM_SEL);
    const addonCard = addBtn.closest(ADDON_ITEM_SEL);
    const card = bundleCard || addonCard;
    if (!card) return;
    const priceEl = card.querySelector(PRICE_SEL);
    if (!priceEl) return;
    const payload = {
      title: addBtn.dataset.title,
      url: addBtn.dataset.url,
      variantId: parseInt(addBtn.dataset.variantId, 10),
      quantity: 1,
      image: addBtn.dataset.image,
      variantTitle: addBtn.dataset.variantTitle,
      comparePrice: parseInt(priceEl.dataset.comparePrice, 10) || 0,
      price: parseInt(priceEl.dataset.price, 10) || 0,
    };
    if (window.EventBus) {
      if (addonCard) {
        window.EventBus.emit("coffeeClub:addon:item:changed", payload);
      } else {
        window.EventBus.emit("coffeeClub:bundle:item:changed", payload);
      }
    }
    announce(`${payload.title} (${payload.variantTitle}) quantity is 1`);
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (modal) {
      const wrap = modal.querySelector(".js-cc-pd-description-wrap");
      if (wrap) wrap.classList.remove("is-expanded");
      const descBtn = modal.querySelector(".js-cc-pd-desc-toggle");
      if (descBtn) {
        descBtn.textContent = "Show more";
        descBtn.setAttribute("aria-expanded", "false");
      }
      modal.setAttribute("aria-hidden", "true");
      modalPayload = null;
    }
  }

  function openModal() {
    const modal = document.getElementById(MODAL_ID);
    if (modal) {
      modal.setAttribute("aria-hidden", "false");
      const focusable = modal.querySelector(".cc-pd-modal__close");
      if (focusable) focusable.focus();
    }
  }

  function emitModalQty(qty) {
    if (!modalPayload || !window.EventBus) return;
    const state = getStateFromStorage();
    const addonModal = modalPayload._isAddon;
    const maxAllowed = addonModal ? 999 : getMaxAllowedQty(state, modalPayload.variantId);
    const capped = Math.min(Math.max(0, qty), maxAllowed);
    const payload = {
      title: modalPayload.title,
      url: modalPayload.url,
      variantId: modalPayload.variantId,
      quantity: capped,
      image: modalPayload.image,
      variantTitle: modalPayload.variantTitle,
      comparePrice: modalPayload.comparePrice != null ? modalPayload.comparePrice : 0,
      price: modalPayload.price,
    };
    if (addonModal) {
      window.EventBus.emit("coffeeClub:addon:item:changed", payload);
    } else {
      window.EventBus.emit("coffeeClub:bundle:item:changed", payload);
    }
    announce(
      payload.quantity > 0
        ? `${payload.title} (${payload.variantTitle}) quantity is ${payload.quantity}`
        : `${payload.title} (${payload.variantTitle}) removed`
    );
  }

  function updateDescriptionClamp(modal) {
    const wrap = modal.querySelector(".js-cc-pd-description-wrap");
    const descEl = modal.querySelector(".cc-pd-modal__description");
    const btn = modal.querySelector(".js-cc-pd-desc-toggle");
    if (!descEl) return;
    if (wrap) wrap.classList.remove("is-expanded");
    if (btn) {
      btn.hidden = true;
      btn.textContent = "Show more";
      btn.setAttribute("aria-expanded", "false");
    }
    if (!wrap || !btn) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var overflow = descEl.scrollHeight > descEl.clientHeight + 2;
        btn.hidden = !overflow;
      });
    });
  }

  function populateModal(product, variant, discountPercent, tagsFromCard, isAddon) {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    const discount = discountPercent != null ? parseInt(discountPercent, 10) : 0;
    const discountedPrice = Math.round((variant.price * (100 - discount)) / 100);
    const linePrice = isAddon ? variant.price : discountedPrice;
    const compareLine =
      isAddon && variant.compare_at_price && variant.compare_at_price > variant.price
        ? variant.compare_at_price
        : isAddon
          ? null
          : variant.price;
    modalPayload = {
      variantId: variant.id,
      title: product.title,
      url: product.url || "/products/" + product.handle,
      image: product.featured_image ? (product.featured_image.src || product.featured_image) : "",
      variantTitle: variant.title,
      comparePrice: compareLine,
      price: linePrice,
      _isAddon: !!isAddon,
    };
    const titleEl = modal.querySelector(".cc-pd-modal__title");
    const imgEl = modal.querySelector(".cc-pd-modal__img");
    const tagsEl = modal.querySelector(".cc-pd-modal__tags");
    const descEl = modal.querySelector(".cc-pd-modal__description");
    const priceEl = modal.querySelector(".cc-pd-modal__price");
    const qtyInput = modal.querySelector(".cc-pd-modal__qty-input");
    const dietaryEl = modal.querySelector(".cc-pd-modal__dietary");
    if (titleEl) titleEl.textContent = product.title;
    if (imgEl) {
      const src = product.featured_image && (product.featured_image.src || product.featured_image);
      imgEl.src = src || "";
      imgEl.alt = product.title || "";
    }
    if (tagsEl) {
      const tags =
        tagsFromCard != null && tagsFromCard !== ""
          ? tagsFromCard.split(",").map((t) => t.trim()).filter(Boolean)
          : [variant.option1, variant.option2, variant.option3].filter(Boolean);
      tagsEl.innerHTML = tags
        .map((t) => '<span class="cc-pd-modal__tag">' + escapeHtml(t) + "</span>")
        .join("");
    }
    if (descEl) {
      descEl.textContent = stripHtml(product.description || "").trim() || product.title;
      updateDescriptionClamp(modal);
    }
    if (priceEl) priceEl.textContent = formatMoney(linePrice);
    if (dietaryEl) dietaryEl.hidden = !!isAddon;
    const state = getStateFromStorage();
    const bundleItems = (state && state.bundleItems) || [];
    const entry = bundleItems.find((item) => item.variantId === variant.id);
    const qty = entry ? entry.quantity : 0;
    if (qtyInput) qtyInput.value = qty;
    const addWrap = modal.querySelector(".js-cc-pd-modal-add-wrap");
    const qtyWrap = modal.querySelector(".js-cc-pd-modal-qty-wrap");
    if (addWrap) addWrap.setAttribute("aria-hidden", qty > 0 ? "true" : "false");
    if (qtyWrap) qtyWrap.setAttribute("aria-hidden", qty > 0 ? "false" : "true");
  }

  function escapeHtml(s) {
    const div = document.createElement("div");
    div.textContent = s;
    return div.innerHTML;
  }

  function onViewDetailsClick(ev) {
    const link = ev.target.closest(VIEW_DETAILS_SEL);
    if (!link) return;
    ev.preventDefault();
    const handle = link.getAttribute("data-product-handle");
    if (!handle) return;
    const tagsFromCard = link.getAttribute("data-product-tags") || "";
    const isAddon = link.getAttribute("data-is-addon") === "true";
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "";
    const url = (root === "/" ? "" : root) + "/products/" + handle + ".js";
    fetch(url)
      .then((res) => res.json())
      .then((product) => {
        const variant = product.variants && product.variants[0] ? product.variants[0] : null;
        if (!variant) return;
        const discount = window.coffeeClub && window.coffeeClub.settings && window.coffeeClub.settings.discount;
        populateModal(product, variant, discount, tagsFromCard, isAddon);
        openModal();
      })
      .catch(() => closeModal());
  }

  function onModalCloseClick(ev) {
    if (ev.target.closest("[data-cc-pd-close]")) closeModal();
  }

  function onDescriptionToggleClick(ev) {
    const btn = ev.target.closest(".js-cc-pd-desc-toggle");
    if (!btn) return;
    const modal = document.getElementById(MODAL_ID);
    if (!modal || modal.getAttribute("aria-hidden") !== "false") return;
    const wrap = modal.querySelector(".js-cc-pd-description-wrap");
    if (!wrap) return;
    ev.preventDefault();
    var expanded = wrap.classList.toggle("is-expanded");
    btn.textContent = expanded ? "Show less" : "Show more";
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
  }

  function onModalAddButtonClick(ev) {
    const btn = ev.target.closest(".js-cc-pd-modal-add-btn");
    if (!btn) return;
    if (btn.disabled) return;
    const modal = document.getElementById(MODAL_ID);
    if (!modal || modal.getAttribute("aria-hidden") !== "false" || !modalPayload) return;
    emitModalQty(1);
    const addWrap = modal.querySelector(".js-cc-pd-modal-add-wrap");
    const qtyWrap = modal.querySelector(".js-cc-pd-modal-qty-wrap");
    const input = modal.querySelector(".cc-pd-modal__qty-input");
    if (addWrap) addWrap.setAttribute("aria-hidden", "true");
    if (qtyWrap) qtyWrap.setAttribute("aria-hidden", "false");
    if (input) input.value = 1;
  }

  function onModalQtyChange(ev) {
    const modal = document.getElementById(MODAL_ID);
    if (!modal || modal.getAttribute("aria-hidden") !== "false") return;
    const input = ev.target.closest(".cc-pd-modal__qty-input");
    if (input) {
      const state = getStateFromStorage();
      const maxAllowed =
        modalPayload && modalPayload._isAddon
          ? 999
          : modalPayload
            ? getMaxAllowedQty(state, modalPayload.variantId)
            : 999;
      const qty = parseInt(input.value, 10) || 0;
      const safe = Math.min(Math.max(0, qty), maxAllowed);
      input.value = safe;
      emitModalQty(safe);
    }
  }

  function onModalQtyButtonClick(ev) {
    const btn = ev.target.closest("[data-cc-pd-qty]");
    if (!btn) return;
    if (btn.disabled) return;
    const modal = document.getElementById(MODAL_ID);
    if (!modal || modal.getAttribute("aria-hidden") !== "false") return;
    if (!modal.contains(ev.target)) return;
    const input = modal.querySelector(".cc-pd-modal__qty-input");
    if (!input) return;
    ev.preventDefault();
    ev.stopPropagation();
    const state = getStateFromStorage();
    const maxAllowed =
      modalPayload && modalPayload._isAddon
        ? 999
        : modalPayload
          ? getMaxAllowedQty(state, modalPayload.variantId)
          : 999;
    const dir = btn.getAttribute("data-cc-pd-qty");
    let val = parseInt(input.value, 10) || 0;
    if (dir === "increment") val = Math.min(val + 1, maxAllowed);
    else if (dir === "decrement") val = Math.max(0, val - 1);
    input.value = val;
    emitModalQty(val);
  }

  function onProductOptionChange(ev) {
    const optionEl = ev.target.closest(".js-product-option");
    if (!optionEl) return;
    const card = optionEl.closest(BUNDLE_ITEM_SEL) || optionEl.closest(ADDON_ITEM_SEL);
    if (!card) return;
    const jsonEl = card.querySelector(".js-product-json");
    const addBtn = card.querySelector(ADD_BTN_SEL);
    if (!jsonEl || !addBtn) return;
    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    const opts = { option1: null, option2: null, option3: null };
    card.querySelectorAll(".js-product-option").forEach(function (el) {
      var name = el.getAttribute("name");
      var val = el.tagName === "SELECT" ? el.value : el.checked ? el.value : null;
      if (name && val != null) opts[name] = decodeURIComponent(val);
    });
    const variant = variants.find(function (v) {
      return (
        (v.option1 == null ? opts.option1 == null : v.option1 === opts.option1) &&
        (v.option2 == null ? opts.option2 == null : v.option2 === opts.option2) &&
        (v.option3 == null ? opts.option3 == null : v.option3 === opts.option3)
      );
    });
    if (!variant) return;
    addBtn.dataset.variantId = variant.id;
    addBtn.dataset.variantTitle = variant.title || "";
    var img = variant.featured_image && (variant.featured_image.src || variant.featured_image);
    if (img) addBtn.dataset.image = typeof img === "string" ? img : img.src || "";
  }

  document.addEventListener("click", onAddButtonClick);
  document.addEventListener("click", onViewDetailsClick);
  document.addEventListener("click", onModalCloseClick);
  document.addEventListener("click", onDescriptionToggleClick);
  document.addEventListener("click", onModalAddButtonClick);
  document.addEventListener("click", onModalQtyButtonClick, true);
  document.addEventListener("change", onModalQtyChange);
  document.addEventListener("change", onProductOptionChange);

  document.addEventListener("keydown", function (ev) {
    if (ev.key !== "Escape") return;
    const modal = document.getElementById(MODAL_ID);
    if (modal && modal.getAttribute("aria-hidden") === "false") closeModal();
  });

  if (window.EventBus) {
    window.EventBus.on("coffeeClub:state:update", toggleAddQtyVisibility);
    window.EventBus.on("collection:filtered", toggleAddQtyVisibility);
  }

  // Apply restored state on load (we may load after the first state:update emit)
  const stored = getStateFromStorage();
  if (stored && stored.bundleItems && stored.bundleItems.length > 0) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function runOnce() {
        document.removeEventListener("DOMContentLoaded", runOnce);
        toggleAddQtyVisibility(stored);
      });
    } else {
      toggleAddQtyVisibility(stored);
    }
  }
})();
